import { render } from "./Game.vue?vue&type=template&id=63d48c50"
const script = {}

import "./Game.vue?vue&type=style&index=0&id=63d48c50&scss=true&lang=css"

import exportComponent from "E:\\project2\\skin-web\\战魂旅人\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__